import WIDGETS from './widgets';

export default {
	name: 'admin_own_organization',
	spacing: 2,
	widgets: [
		{ content: WIDGETS.ORGANIZATION, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 },
		{ content: WIDGETS.CLIENT_ORGANIZATION, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 },
	],
};
